import { defineComponent as _defineComponent } from 'vue'
import { EventOrganizer } from '@/models/EventOrganizer';
import EventOrganizerSelect from '../event/EventOrganizerSelect.vue';
import { ref, Ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAdditionalEoDlg',
  props: {
    persistent: { type: Boolean },
    value: { type: Boolean }
  },
  emits: ['input', 'cancel', 'selected'],
  setup(__props: any, { emit }) {

const props = __props as {
    persistent: boolean;
    value: boolean;
};





const selectedEO: Ref<EventOrganizer | null> = ref(null);

watch(
    () => props.value,
    (newVal, oldVal) => {
        if (newVal && !oldVal) {
            selectedEO.value = null;
        }
    },
);

function onEventOrganizerSelect(eventOrganizer: EventOrganizer) {
    selectedEO.value = eventOrganizer;
}

function cancel() {
    emit('cancel');
    emit('input', false);
}

function confirm() {
    emit('selected', selectedEO.value);
    emit('input', false);
}

return { __sfc: true,props, emit, selectedEO, onEventOrganizerSelect, cancel, confirm, EventOrganizerSelect }
}

})